var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFurnitureAndHomewares = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Armchair--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Armchair Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.54 8.42h0.3A5.28 5.28 0 0 1 9.07 13a0.48 0.48 0 0 0 0.56 0.42 19.58 19.58 0 0 1 2.37 -0.21 19.58 19.58 0 0 1 2.37 0.17 0.48 0.48 0 0 0 0.56 -0.42 5.28 5.28 0 0 1 5.23 -4.55h0.3a0.52 0.52 0 0 0 0.54 -0.57 9.12 9.12 0 0 0 -18 0 0.52 0.52 0 0 0 0.53 0.58Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 9.85a3.84 3.84 0 0 0 -3.84 3.84 4.26 4.26 0 0 0 0.08 0.8 0.49 0.49 0 0 1 -0.13 0.46 0.51 0.51 0 0 1 -0.45 0.14 20.07 20.07 0 0 0 -3.82 -0.44 20.07 20.07 0 0 0 -3.82 0.44 0.51 0.51 0 0 1 -0.45 -0.09 0.49 0.49 0 0 1 -0.13 -0.46 4.26 4.26 0 0 0 0.08 -0.8 3.84 3.84 0 0 0 -7.68 0 3.79 3.79 0 0 0 2.23 3.47 0.5 0.5 0 0 1 0.27 0.6 2.18 2.18 0 0 0 -0.1 0.67v1.38a1.45 1.45 0 0 0 1.44 1.44H4a0.5 0.5 0 0 1 0.5 0.5v0.75a1.25 1.25 0 0 0 2.5 0v-0.75a0.5 0.5 0 0 1 0.5 -0.5h9a0.5 0.5 0 0 1 0.5 0.5v0.75a1.25 1.25 0 0 0 2.5 0v-0.75a0.5 0.5 0 0 1 0.5 -0.5h0.16a1.45 1.45 0 0 0 1.44 -1.44v-1.43a2.18 2.18 0 0 0 -0.1 -0.67 0.5 0.5 0 0 1 0.27 -0.6A3.79 3.79 0 0 0 24 13.69a3.84 3.84 0 0 0 -3.84 -3.84Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFurnitureAndHomewares);
export default ForwardRef;